// ================================================================
// Modals — راه‌اندازی همه modalها
// ================================================================

import './modals.css';
import { initSettingsModal } from './SettingsModal.js';
import { initPickerModal } from './PickerModal.js';

export function initModals(root) {
  initSettingsModal(root);
  initPickerModal(root);

  // ESC برای بستن همه modalها
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      root.querySelectorAll('.modal-backdrop:not(.hidden)').forEach(b => {
        b.classList.add('hidden');
      });
    }
  });
}
